import { colorsPalettes } from "@similarweb/styles";
import { CircleSwitcherItem } from "@similarweb/ui-components";
import {
    GraphTypeSwitcherContainer,
    StyledSWReactIcons,
} from "app/pages/website-analysis/TrafficAndEngagement/Components/StyledComponents";
import type { ReactNode } from "react";
import type { FC } from "react";
import type { IconSize, IconName } from "@similarweb/icons";
import styled from "styled-components";
import { PlainTooltip } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";

const CircleSwitcherItemStyled = styled(CircleSwitcherItem)`
    padding: 7px;
` as FC<{ children: ReactNode; key: number; disabled: boolean }>;

const SwitcherItemWrapperForTooltip = styled.div<{ disabled: boolean }>`
    display: inline-block;
    ${({ disabled }) => (disabled ? "cursor: not-allowed;" : "")}
`;

interface Icon {
    size: IconSize;
    name: IconName;
    disabled?: boolean;
}

type Icons = Array<Icon>;

interface IGraphTypeItemsArgs {
    icons: Icons;
    selectedIndex: number;
    Container?: FC<{ children?: ReactNode; key: number; disabled: boolean }>;
}

interface IGraphTypeSwitcher extends IGraphTypeItemsArgs {
    onItemClick: (selectedIndex: number) => void;
}

export const GraphTypeSwitcher: FC<IGraphTypeSwitcher> = ({ onItemClick, selectedIndex, icons }) => (
    <GraphTypeSwitcherContainer
        selectedIndex={selectedIndex}
        onItemClick={onItemClick}
    >
        {getGraphTypeItems({ icons, selectedIndex })}
    </GraphTypeSwitcherContainer>
);

const getGraphTypeItems = ({ icons, selectedIndex, Container = CircleSwitcherItem }: IGraphTypeItemsArgs) => {
    const graphTypeItems = icons.map(({ size, name, disabled = false }, index) => (
        <SwitcherItemWrapperForTooltip disabled={disabled}>
            <PlainTooltip
                tooltipContent={translate("market.players.market.shares.graph.stacked.disabled.tooltip")}
                enabled={name === "stacked-chart" && disabled}
            >
                <div>
                    <Container
                        key={index}
                        disabled={disabled}
                    >
                        <StyledSWReactIcons
                            size={size}
                            iconName={name}
                            color={index === selectedIndex ? colorsPalettes.blue[400] : undefined}
                        />
                    </Container>
                </div>
            </PlainTooltip>
        </SwitcherItemWrapperForTooltip>
    ));
    return graphTypeItems;
};
